function toggleExpandedState() {
    const currentExpandedState = this.getAttribute("aria-expanded");
    const newExpandedState = currentExpandedState === "true" ? "false" : "true";
    this.setAttribute("aria-expanded", newExpandedState);

}

const expandContentElements = document.querySelectorAll('[expand-content]');
expandContentElements.forEach(function (element) {
    element.addEventListener('click', toggleExpandedState);
});